import { ref } from 'vue'
import { useDemoMode } from './useDemoMode'

// Module-level singleton so the global search overlay — rendered once in
// AppRoot.vue, the only component that stays mounted across every route —
// can be opened from anywhere: the "/" shortcut, or the search button in
// HeaderControls.vue, which is shared across the dashboard/admin/team-
// calendar top bars.
const isOpen = ref(false)

// Admin / lesson_signups only — teachers get neither the button, the "/"
// shortcut, nor the overlay. Builds a fresh computed per call (not one cached
// at module level) since `user` lives in localStorage and would go stale
// across a login — same reason as AppRoot.vue's storedUser().
const readOwnPermissions = () => {
  try { return JSON.parse(localStorage.getItem('user') || 'null')?.permissions } catch { return null }
}
function canUse() {
  const perms = useDemoMode().effectivePermissionsFor(readOwnPermissions).value
  return perms.includes('admin') || perms.includes('lesson_signups')
}

export function useGlobalSearch() {
  return {
    isOpen,
    canUse,
    open: () => { if (canUse()) isOpen.value = true },
    close: () => { isOpen.value = false },
  }
}
